import React from 'react';
import { motion } from 'framer-motion';
import { Search, Zap, Route } from 'lucide-react';
export function WhatIsSection() {
  const benefits = [{
    icon: <Search size={32} className="text-amber-500" data-id="element-207" />,
    title: 'Discover what truly matters',
    description: 'Cut through the noise. Our structured conversations help you identify the core signals hidden within everyday interactions.'
  }, {
    icon: <Zap size={32} className="text-amber-500" data-id="element-208" />,
    title: 'Transform experience into actionable knowledge',
    description: "We don't just store data. We synthesize human experience into modular, usable insights ready for execution."
  }, {
    icon: <Route size={32} className="text-amber-500" data-id="element-209" />,
    title: 'Build pathways toward meaningful futures',
    description: 'Turn insights into clear, step-by-step actions that align individuals, communities, and organizations.'
  }];
  return <section id="philosophy" className="py-24 bg-gray-50" data-id="element-210">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-211">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-212">
          <h2 className="text-teal-600 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-213">
            What is Latteware?
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-214">
            A knowledge activation company.
          </h3>
          <p className="text-xl text-gray-600" data-id="element-215">
            We don't just capture information.{' '}
            <span className="font-semibold text-gray-900" data-id="element-216">We activate it.</span>
          </p>
          <p className="mt-4 text-gray-600" data-id="element-217">
            Through structured conversations, AI-powered synthesis, and human
            collaboration, we help individuals, communities, and organizations
            unlock their potential.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-218">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-219">
              <div className="w-16 h-16 bg-amber-50 rounded-lg flex items-center justify-center mb-6" data-id="element-220">
                {benefit.icon}
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-221">
                {benefit.title}
              </h4>
              <p className="text-gray-600 leading-relaxed" data-id="element-222">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}